import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SmartOptinsExperience } from '../common-types/smartOptins.type';

type SmartOptinsState = {
  smartOptinsExperience: SmartOptinsExperience | null,
  hasSmartOptinsExperience: boolean;
};

const initialState: SmartOptinsState = {
  smartOptinsExperience: null,
  hasSmartOptinsExperience: false,
};

export const smartOptinsSlice = createSlice({
  initialState,
  name: 'SmartOptinsSlice',
  reducers: {
    setSmartOptins (
      state: SmartOptinsState,
      { payload }: PayloadAction<{ smartOptinsExperience: SmartOptinsExperience | null }>
    ): SmartOptinsState {
      return {
        smartOptinsExperience: payload.smartOptinsExperience,
        hasSmartOptinsExperience: payload.smartOptinsExperience !== null,
      };
    },
  },
});

const { actions, reducer } = smartOptinsSlice;

export const { setSmartOptins } = actions;
export default reducer;
